export enum CallCoachingStatus {
  PROVIDED = 'PROVIDED',
  REQUESTED = 'REQUESTED',
  NONE = 'NONE',
}
